import { request, requestNotif } from '@/_helpers/requests'
import { cookie } from '@/_utils/cookie'
import { ClientJS } from 'clientjs';

export const userService = {
    login(user) {
    
        let client = new ClientJS();
        user.Fingerprint = client.getFingerprint().toString();

        cookie.removeToken();
        
        return new Promise((resolve) => {
            
            request.post('access/login', user).then(response => {
                
                cookie.setToken(response.data.token);
                
                resolve({'isadmin': response.data.isadmin, 'changePassword': response.data.changepassword==1, 'expirationDays': response.data.expirationDays, valid: true, 'fingerprintWarning': response.data.fingerprintWarning});
            }, error => {

                let dataResult = error.response.data;
                dataResult['valid'] = false;
                
                resolve(dataResult);
            }).catch(function() {
                resolve({valid: false});
            });
        });
    },
    logout() {

        return new Promise((resolve) => {
            
            request.get('userLogout').then(response => {
                cookie.removeToken();
                resolve(response.status == 200);
            });
        });
    },
    validateFingerprint(fingerprint) {

        return new Promise((resolve) => {
            request.post('access/validateFingerprint?fingerprint='+fingerprint).then(response => {                
                
                resolve({'valid': response.status == 200});
            }, error => {

                let dataResult = error.response.data;
                dataResult['valid'] = false;
                
                resolve(dataResult);
            }).catch(function() {
                resolve({valid: false});
            });
        });
    },

    recover(user) {
    
        return new Promise((resolve) => {
    
            request.post('access/recover', user).then(response => {
                let dataResult = response.data;
                dataResult['valid'] = response.status == 200;
                
                resolve(dataResult);
            }).catch(function(error) {
                let dataResult = error.response.data;
                dataResult['valid'] = false;
                resolve(dataResult);
            });
        });
    },
    recoverQuestion(user) {
        return new Promise((resolve) => {
    
            request.get('access/recoverQuestion?username='+user).then(response => {
                resolve(response.data);
            });
        });

    },
    validateRecover(passwords) {
    
        return new Promise((resolve) => {
    
            request.post('access/validateRecover', passwords).then(response => {
                resolve(response.status == 200);
            }).catch(function() {
                resolve(false);
            });
        });
    },
    changePassword(password) {

        return new Promise((resolve) => {
            requestNotif.post('user/changePassword', password).then((response) => {
                //notification.success('La contraseña ha sido modificada');
                resolve(response.status == 200);
            });
        });
    },
    getPasswordPattern() {

        return new Promise((resolve) => {
            request.get('getPasswordPattern').then((response) => {
                resolve(response.data);
            });
        });
    },
    userData() {

        return new Promise((resolve) => {
            requestNotif.get('userData').then((response) => {
                resolve(response.data);
            });
        });
    },
    userEmailInform(email) {

        return new Promise((resolve) => {
            requestNotif.post('userEmailInform',{email: email}).then((response) => {
                resolve(response.status == 200);
            });
        });
    },
    sendMigration(email) {
        return new Promise((resolve) => {
            request.post('empleado/sendMailMigration',{email: email}).then(response => {
                resolve(response.status == 200);
            }, error => {
                let dataResult = error.response.data;
                resolve(dataResult);
            }).catch(function() {
                resolve(false);
            });

        });
    },
    validationMigration(code) {
        return new Promise((resolve) => {
            request.post('empleado/validationMailMigration',{code: code}).then(response => {
                resolve(response.status == 200);
            }, error => {
                let dataResult = error.response.data;
                resolve(dataResult);
            }).catch(function() {
                resolve(false);
            });

        });
    },
    userAuthenticator() {
        return new Promise((resolve) => {
            request.get('userAuthenticator').then((response) => {
                resolve(response.data);
            });
        });
    },
    updateUserData(data) {

        return new Promise((resolve) => {
            requestNotif.post('user/updateData', data).then(() => {
                resolve(true);
            });
        });
    },
};